import { throwIfNotOk } from "./apiError";

export type MappingData = {
    unit_id: Record<string, string>;
    phenomenon_id: Record<string, string>;
    drive_mode_id: Record<string, string>;
    condition_group_id: Record<string, string>;
};

export const fetchMapping = async (authToken: string): Promise<MappingData> => {
    const baseURL = process.env.REACT_APP_URL;
    const response = await fetch(`${baseURL}/config/mapping`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': authToken,
        },
    });

    await throwIfNotOk(response, "fetchMapping");

    const body = await response.json();
    return body.mapping;
};
